"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//pollyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}
//jquery
require("expose-loader?exposes=$!jquery");
require("expose-loader?exposes=jQuery!jquery");
//router
var router_1 = require("./router");
//jquery pagination
require('imports-loader!simple-pagination.js/jquery.simplePagination.js');
//bootstrap
require("bootstrap");
//css
require("../css/main.scss");
//glyphicons
require("owp.glyphicons/glyphicons.min.css");
router_1.Router.loadRouter();
